// extracted by mini-css-extract-plugin
module.exports = {"teamMember":"styles-module--teamMember--1_lxL","photo":"styles-module--photo--1Z16m","content":"styles-module--content--2FQPL"};